import api from '../../api/axios';
import { showError, showSuccess } from '../../Components/reuse/Toast';

export const UPS_CONNECT_REQUEST = 'UPS_CONNECT_REQUEST';
export const UPS_CONNECT_SUCCESS = 'UPS_CONNECT_SUCCESS';
export const UPS_CONNECT_FAILURE = 'UPS_CONNECT_FAILURE';
export const UPS_DISCONNECT_REQUEST = 'UPS_DISCONNECT_REQUEST';
export const UPS_DISCONNECT_SUCCESS = 'UPS_DISCONNECT_SUCCESS';
export const UPS_DISCONNECT_FAILURE = 'UPS_DISCONNECT_FAILURE';

export const connectUPS = (payload) => async (dispatch) => {
  dispatch({ type: UPS_CONNECT_REQUEST });
  try {
    const response = await api.post('ups/connectUPS', payload);
    const data = response?.data || {};
    if (data?.success) {
      dispatch({ type: UPS_CONNECT_SUCCESS, payload: data });
      if (data?.message) showSuccess(data.message);
      return data;
    }
    const message = data?.message || 'Failed to connect UPS';
    dispatch({ type: UPS_CONNECT_FAILURE, error: message });
    showError(message);
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to connect UPS';
    dispatch({ type: UPS_CONNECT_FAILURE, error: message });
    showError(message);
    return { success: false, message };
  }
};

export const disconnectUPS = () => async (dispatch) => {
  dispatch({ type: UPS_DISCONNECT_REQUEST });
  try {
    const response = await api.post('ups/disconnectUPS');
    const data = response?.data || {};
    if (data?.success) {
      dispatch({ type: UPS_DISCONNECT_SUCCESS, payload: data });
      if (data?.message) showSuccess(data.message);
      return data;
    }
    const message = data?.message || 'Failed to disconnect UPS';
    dispatch({ type: UPS_DISCONNECT_FAILURE, error: message });
    showError(message);
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to disconnect UPS';
    dispatch({ type: UPS_DISCONNECT_FAILURE, error: message });
    showError(message);
    return { success: false, message };
  }
};


